import { RiErrorWarningLine } from "react-icons/ri";
import ModalInfo from "../../../../components/lib/modalInfo";
import { GrCircleQuestion } from "react-icons/gr";
import { AiOutlineClose } from "react-icons/ai";

const ComboRegisterFormStep1 = ({ formik }) => {

    const handleImageChange = (file) => {
        if (!file) return;

        formik.setFieldValue("imageFile", file);
        formik.setFieldValue("imagePreview", URL.createObjectURL(file));
        formik.setFieldTouched("imageFile", true);
    };

    return (
        <div className="space-y-6 max-w-5xl mx-auto">
            <div>
                <p className="mb-2 font-medium text-sm text-gray-700">Imagem do Combo</p>

                <div className={`flex justify-center border-2 border-dashed rounded-xl p-4 transition-all
                    ${formik.errors.imageFile ? "border-red-500 bg-red-50" : "border-gray-300 hover:border-custom_blue/50"}`}>

                    {formik.values.imagePreview ? (
                        <div className="relative w-48 h-48">
                            <img
                                src={formik.values.imagePreview}
                                className="w-full h-full object-contain rounded-lg shadow-sm"
                                alt="Preview do Combo"
                            />
                            <button
                                type="button"
                                onClick={() => {
                                    formik.setFieldValue("imageFile", null);
                                    formik.setFieldValue("imagePreview", null);
                                }}
                                className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1.5 shadow-md hover:bg-red-600 transition-colors"
                            >
                                <AiOutlineClose size={16} />
                            </button>
                        </div>
                    ) : (
                        <label className="cursor-pointer text-gray-500 w-full py-10 flex flex-col items-center">
                            <input
                                type="file"
                                hidden
                                accept="image/*"
                                onChange={(e) => handleImageChange(e.target.files[0])}
                            />
                            <span className="text-custom_blue font-semibold">Clique para selecionar</span>
                            <span className="text-xs mt-1">Limite de 25MB (JPG, PNG)</span>
                        </label>
                    )}
                </div>
                {formik.errors.imageFile && (
                    <p className="text-red-500 text-xs mt-2 ">
                        {formik.errors.imageFile}
                    </p>
                )}
            </div>

            {/* NOME */}
            <label>
                <div className="flex relative items-center justify-between">
                    <p>Nome do Combo:</p>
                    <ModalInfo icon={<RiErrorWarningLine />} content="Campo Obrigatório!" />
                </div>

                <input className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.name && formik.errors.name ? 'border-red-500' : ''}`}
                    name="name"
                    type="text"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name} />

                {formik.touched.name && formik.errors.name && (<p className="text-red-500 text-xs font-medium relative my-2">{formik.errors.name}</p>)}
            </label>

            <div className="grid lg:grid-cols-2 gap-x-4">
                <label>
                    <div className="flex items-center justify-between">
                        <p>Preço:</p>
                        <ModalInfo icon={<RiErrorWarningLine />} content="Campo Obrigatório!" />
                    </div>
                    <input className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.price && formik.errors.price ? 'border-red-500' : ''}`}
                        name="price"
                        type="number"
                        step="0.01"
                        min="0.00"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.price} />

                    {formik.touched.price && formik.errors.price && (<p className="text-red-500 text-xs font-medium relative my-2">{formik.errors.price}</p>)}
                </label>

                <label>
                    <p>Preço Online (R$):</p>
                    <input className="block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        name="online_price"
                        type="number"
                        step="0.01"
                        min="0.00"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.online_price} />
                    <p className="text-xs text-gray-400 mt-1">Opcional. Usado nas compras online pelo responsável.</p>
                </label>
            </div>

            <div className="grid lg:grid-cols-2 gap-x-4">
                <label>
                    <div className="flex items-center justify-between">
                        SKU:
                        <ModalInfo icon={<GrCircleQuestion />} content="Código que facilita a organização dos itens. É um meio de você identificar produtos, sem precisar gravar seu código de barras por exemplo. Permite que você estabeleça seu próprio padrão para organização." />
                    </div>
                    <input className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.sku && formik.errors.sku ? 'border-red-500' : ''}`}
                        name="sku"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.sku} />

                    {formik.touched.sku && formik.errors.sku && (<p className="text-red-500 text-xs font-medium absolute">{formik.errors.sku}</p>)}
                </label>
            </div>

            <div className="grid md:grid-cols-2 gap-4 mt-6 w-full">
                <label className="flex items-center gap-3 cursor-pointer">
                    <input
                        type="checkbox"
                        name="active"
                        checked={formik.values.active}
                        onChange={formik.handleChange}
                        className="w-4 h-4 accent-blue-600" />
                    <span className="text-sm font-medium text-gray-700"> Ativar produto no cardápio </span>
                </label>
            </div>
        </div>
    );
};

export default ComboRegisterFormStep1;
